module.exports = __webpack_public_path__ + "img/teamImg12.a567ed0d.jpg";